<template>
  <div>
    <div id="echartB"></div>
  </div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "BarCharts",
  components: {},
  props: {
    echartsData: {
      type: Array,
      default: {
        return: {},
      }
    }
  },
  data() {
    return {
      myChart: {},
    };
  },
  created() {

  },
  mounted() {
    let _this = this;
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.loadEchart();
    });
  },
  computed: {},
  watch:{
    'echartsData':function(newVal){
        this.loadEchart()
    }

  },
  methods: {
    loadEchart() {
      let colors = this.$store.state.select.riskLevel.map((item)=>{
                return item.backgroundColor
            })
      this.myChart = Echarts.init(document.getElementById("echartB"));
      let option = {
        title: {
          // text: "折线图堆叠",
        },
        tooltip: {
          // trigger: "axis",
        },
        legend: {
          // show: false,
          // itemWidth: 14,
          // itemHeight: 14,
          // icon: 'rect',
          bottom: "bottom",
          textStyle: {
            color: '#B4BBE0',
          },
          data: []
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "12%",
          bottom: "10%",
          containLabel: true,
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: 'value',
          // nameTextStyle: {
          //   color: "#B4BBE0",
          //   fontSize: 14
          // },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#B4BBE0",
              fontSize: "10",
            },
          },
          boundaryGap: false,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#4868AF",
              type: "dash",
              opacity: 0.5,
              fontSize: 14,
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1,
            },
          },
        },
        yAxis: {
          type: 'category',
          data: [],
          nameTextStyle: {
            color: "#B4BBE0",
            fontSize: 16,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: "16",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              // show: false,
              type: "dash",
              opacity: 0.5,
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1,
            },
          },
        },
        series: [
          {
            data: [],
            type: 'bar',
            barMaxWidth:'22',
            itemStyle: {
            // width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6,
              normal:{
　　　　　　　　　//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function (params){
                  return colors[params.dataIndex];
                },
                barWidth : 22,//柱条的宽度
                label: {
                  show: true,      //开启显示
                  position: 'right', //在上方显示
                  textStyle: {     //数值样式
                    color: '#B3BEF4',
                    fontSize: 20
                  }
                }
              },
            },
          },
        ],
        color: colors,
      };
      option.yAxis.data = this.echartsData.map((item,index)=>{
        return {
          value:String.fromCharCode(64 + parseInt(index + 1)) || ''
        }
      })
      option.series[0].data = this.echartsData.map((item,index)=>{
        return {
          name:String.fromCharCode(64 + parseInt(index + 1)) || '',
          value:item.scale*100 || 0
        }
      })
      this.myChart.setOption(option);
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
#echartB{
  width: 250px;
height: 250px;
}
</style>
